import { RouteProps } from 'react-router';
import { routes as flowsRoutes, RegisterPharmacyFlow } from './flows';
import { GenericErrorScreen, NotFoundScreen } from '@screens';

interface ScreenRoute {
	[key: string]: RouteProps;
}

const screensRoutes: any[] = [];

export const SCREENS = {
	default: {
		path: '/',
		component: RegisterPharmacyFlow,
		exact: true,
	},
	genericError: {
		path: '/error',
		component: GenericErrorScreen,
	},
	notFound: {
		path: '/notfound',
		component: NotFoundScreen,
	},
};

screensRoutes.push(SCREENS.default);

export default [...screensRoutes, ...flowsRoutes];
